const PAYMENT_PENDING = 'PAYMENT_ANALYSIS'
const PAYMENT_NOT_APPROVED = 'DONT_SHOW'
const PAYMENT_REPROVED = 'DONT_SHOW'
const IN_PREPARATION_CONFIRMED = 'CONFIRMED'
const IN_PREPARATION_AWAITING = 'AWAITING_STOCK'
const IN_PREPARATION_RESERVED = 'STOCK_RESERVED'
const IN_PREPARATION_BILLED = 'BILLED'
const CANCELED = 'CANCELED_REFUND_NEEDED'
const FINISHED = 'DELIVERED'
const CLUSTERS = [
  PAYMENT_PENDING,
  PAYMENT_NOT_APPROVED,
  PAYMENT_REPROVED,
  IN_PREPARATION_CONFIRMED,
  IN_PREPARATION_AWAITING,
  IN_PREPARATION_RESERVED,
  IN_PREPARATION_BILLED,
  CANCELED,
  FINISHED
]

module.exports = {
  PAYMENT_PENDING,
  PAYMENT_NOT_APPROVED,
  PAYMENT_REPROVED,
  IN_PREPARATION_CONFIRMED,
  IN_PREPARATION_AWAITING,
  IN_PREPARATION_RESERVED,
  IN_PREPARATION_BILLED,
  CANCELED,
  FINISHED,
  CLUSTERS
}
